import { PrismicRichText } from '@prismicio/react'
import React, { memo } from 'react'

const RadioButton = ({ item, checked, onChange }) => (
  <label className={`radio-button`}>
    <input
      type="radio"
      checked={checked}
      disabled={item.disabled}
      value={item.id}
      name={item.id}
      onChange={(e) => onChange(e.target.id)}
      id={item.id}
    />
    <span>
      <PrismicRichText field={[item.label]} />
    </span>
  </label>
)

export default memo(RadioButton)
